import PropTypes from "prop-types"


const properties = {
  distributionsAmount: PropTypes.number.isRequired,
  investmentId: PropTypes.string.isRequired,
  projectId: PropTypes.string.isRequired,
  year: PropTypes.number
}

const InvestmentTransactionReportShape = PropTypes.exact(properties)

export default InvestmentTransactionReportShape
export { properties }
